/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
/* UI Action Types */
export const SET_PROPERTY = 'SET_PROPERTY';
export const REPLACE_PROPERTY = 'REPLACE_PROPERTY';
export const FIELD_CHANGE = 'FIELD_CHANGE';
export const SHOW_HARNESS = 'SHOW_HARNESS';
export const LOCAL_ACTION = 'LOCAL_ACTION';
export const CLOSE_CONTAINER = 'CLOSE_CONTAINER';
export const RUN_SCRIPT = 'RUN_SCRIPT';
export const LOAD_VIEW = 'LOAD_VIEW';
export const SHOW_PAGE = 'SHOW_PAGE';
export const OPEN_STAGE = 'OPEN_STAGE';
export const SHOW_DATA = 'SHOW_DATA';
export const SHOW_INSIGHT = 'SHOW_INSIGHT';
export const SHOW_DASHBOARD = 'SHOW_DASHBOARD';
export const HOME = 'HOME';
export const SET_LOADING = 'SET_LOADING';
export const RESET_LOADING = 'RESET_LOADING';
export const SET_SHARED_PROPERTY = 'SET_SHARED_PROPERTY';

/* Case Action Types */
export const ADD_WORK = 'ADD_WORK';
export const CREATE_WORK = 'CREATE_WORK';
export const OPEN_WORK_BY_HANDLE = 'OPEN_WORK_BY_HANDLE';
// TODO Remove document related action names as we have introduced container actions*/
export const ADD_DOCUMENT = 'ADD_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const REPLACE_DOCUMENT = 'REPLACE_DOCUMENT';
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT';
export const FINISH_ASSIGNMENT = 'FINISH_ASSIGNMENT';
export const SAVE_AND_CLOSE = 'SAVE_AND_CLOSE';
export const CANCEL_ASSIGNMENT = 'CANCEL_ASSIGNMENT';
export const UPDATE_WORKLIST = 'UPDATE_WORKLIST';
export const DELETE_CASE_IN_CREATESTAGE = 'DELETE_CASE_IN_CREATESTAGE';
export const OPEN_ASSIGNMENT = 'OPEN_ASSIGNMENT';
export const GET_DESCENDANTS = 'GET_DESCENDANTS';
export const NAVIGATE_TO_STEP = 'NAVIGATE_TO_STEP';
export const SHOW_CREATE_STAGE_CANCEL_ALERT = 'SHOW_CREATE_STAGE_CANCEL_ALERT';
export const OPEN_LOCAL_ACTION = 'OPEN_LOCAL_ACTION';
export const SUBMIT_BULK_ACTION = 'SUBMIT_BULK_ACTION';
export const SUBMIT_BULK_ACTION_ASYNC = 'SUBMIT_BULK_ACTION_ASYNC';
export const OPEN_BULK_ACTION = 'OPEN_BULK_ACTION';

/* Data Action Types */
export const GET_DATA = 'GET_DATA';
export const MERGE_DATA = 'MERGE_DATA';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const GETDATAOBJECTACTIONS = 'GET_DATAOBJECT_ACTIONS';

/* History Action Types */
export const SHOW_HISTORY = 'SHOW_HISTORY';

export const POST_PROCESS = 'POST_PROCESS';
export const ERROR = 'ERROR';

/* Container Action Types */
export const INIT_CONTAINERS = 'INIT_CONTAINERS';
export const RESET_CONTAINERS = 'RESET_CONTAINERS';
export const ADD_CONTAINER_ITEM = 'ADD_CONTAINER_ITEM';
export const REMOVE_CONTAINER_ITEM = 'REMOVE_CONTAINER_ITEM';
export const ADD_TRANSIENT_ITEM = 'ADD_TRANSIENT_ITEM';
export const UPDATE_TRANSIENT_DATA = 'UPDATE_TRANSIENT_DATA';
export const REMOVE_TRANSIENT_ITEM = 'REMOVE_TRANSIENT_ITEM';
export const REMOVE_ALL_TRANSIENT_ITEMS = 'REMOVE_ALL_TRANSIENT_ITEMS';
export const CLEAR_TRANSIENT_DATA = 'CLEAR_TRANSIENT_DATA';
export const PURGE_TRANSIENT_DATA = 'PURGE_TRANSIENT_DATA';
export const REPLACE_TRANSIENT_DATA = 'REPLACE_TRANSIENT_DATA';
export const ACTIVATE_CONTAINER_ITEM = 'ACTIVATE_CONTAINER_ITEM';
export const UPDATE_CONTAINER_ITEM = 'UPDATE_CONTAINER_ITEM';
export const UPMERGE_AND_REMOVE_CONTAINER_ITEM = 'UPMERGE_AND_REMOVE_CONTAINER_ITEM';
export const REPLACE_CONTAINER_ITEM = 'REPLACE_CONTAINER_ITEM';
export const ACTIVATE_MODAL_CONTAINER_ITEM = 'ACTIVATE_MODAL_CONTAINER_ITEM';
export const REMOVE_CONTAINER = 'REMOVE_CONTAINER';
export const ADD_SUGGESTION_CONTEXT = 'ADD_SUGGESTION_CONTEXT';

/* Container actions to identify the view container */
export const ACTION_SHOWVIEW = 'showView';
export const ACTION_SHOWDATA = 'showData';
export const ACTION_SHOWINSIGHT = 'showInsight';
export const ACTION_SHOWDASHBOARD = 'showDashboard';
export const ACTION_OPENWORKBYHANDLE = 'openWorkByHandle';
export const ACTION_GETDESCENDANTS = 'getDescendants';
export const GET_CASE_STAGES = 'getCaseStages';
export const ACTION_OPENASSIGNMENT = 'openAssignment';
export const ACTION_OPENSTAGE = 'openStage';
export const ACTION_RETRIEVE_ASSIGNMENT = 'retrieveAssignment';
export const ACTION_CREATEWORK = 'createNewWork';
export const ACTION_SHOWHARNESS = 'showHarness';
export const ACTION_FINISHASSIGNMENT = 'finishAssignment';
export const ACTION_ADDWORK = 'addWork';
export const ACTION_CANCEL_ASSIGNMENT = 'cancelAssignment';
export const SHOW_CANCEL_ALERT = 'SHOW_CANCEL_ALERT';
export const ACTION_SAVE_AND_CLOSE = 'saveAndClose';
export const ACTION_SAVE = 'save';
export const ACTION_RELEASE_ASSIGNMENT_LOCK = 'releaseAssignmentLock';
export const ACTION_DELETE_CASE_IN_CREATESTAGE = 'deleteCaseInCreateStage';
export const ACTION_NAVIGATE_TO_STEP = 'navigateToStep';
export const ACTION_OPEN_LOCAL_ACTION = 'openLocalAction';
export const ACTION_OPEN_PROCESS_ACTION = 'openProcessAction';
export const ACTION_OPEN_CASE_WIDE_LOCAL_ACTION = 'caseWideActions';
export const ACTION_EXECUTE_CASE_WIDE_LOCAL_ACTION = 'executeCaseWideActions';
export const ACTION_OPEN_BULK_ACTION = 'openBulkAction';
export const ACTION_GET_BULK_ACTIONS = 'getBulkActions';
export const ACTION_GET_BULK_ACTIONS_BY_CASETYPE = 'getCaseBulkActions';
export const ACTION_SUBMIT_BULK_ACTIONS = 'performBulkAction';
export const ACTION_CREATE_DATA_OBJECT = 'createDataObject';
export const GET_DATA_OBJECT_ACTIONS = 'getDataObjectActions';
export const ACTION_DELETE_DATA_OBJECT = 'deleteDataObject';
export const ACTION_GET_DATA_OBJECT_VIEW = 'readDataObject';
export const ACTION_UPDATE_DATA_OBJECT = 'updateDataObject';
export const ACTION_LAUNCH_ASSIGNMENT = 'launchAssignment';

export const ACTION_GETNEXTWORK = 'getNextWork';

/* Error action  */
export const ERRORS = 'ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_PAGE_MESSAGES = 'CLEAR_PAGE_MESSAGES';
export const CLEAR_FIELD_MESSAGES = 'CLEAR_FIELD_MESSAGES';
export const GET_MESSAGES = 'GET_MESSAGES';
export const ADD_MESSAGES = 'ADD_MESSAGES';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

/* Reset Store (to initial state) - needed by Mashup */
export const RESET_STORE = 'RESET_STORE';

/* Datapage actions */
export const FETCH_DATAPAGE = 'FETCH_DATAPAGE';
export const ADD_SHARED_DATA = 'ADD_SHARED_DATA';
export const REMOVE_SHARED_DATA = 'REMOVE_SHARED_DATA';

export const LIST_ACTION = 'LIST_ACTION';

/* Case Preview Actions */
export const SHOW_CASE_PREVIEW = 'SHOW_CASE_PREVIEW';
export const DELETE_CASE_SUMMARY = 'DELETE_CASE_SUMMARY';

/* ActionsSequencer Actions */
export const ALTER_BLOCKING_ACTION_COUNT = 'ALTER_BLOCKING_ACTION_COUNT';

/* Data object Actions */
export const CREATE_DATA_OBJECT = 'CREATE_DATA_OBJECT';
export const DELETE_DATA_OBJECT = 'DELETE_DATA_OBJECT';
export const VIEW_DATA_OBJECT = 'VIEW_DATA_OBJECT';
export const UPDATE_DATA_OBJECT = 'UPDATE_DATA_OBJECT';
export const OPEN_DATA_OBJECT_ACTION = 'OPEN_DATA_OBJECT_ACTION';
export const SUBMIT_DATA_OBJECT_ACTION = 'SUBMIT_DATA_OBJECT_ACTION';

/* Embedded Data Actions */
export const OPEN_EMBEDDED_DATA_MODAL = 'OPEN_EMBEDDED_DATA_MODAL';
export const SUBMIT_EMBEDDED_DATA_MODAL = 'SUBMIT_EMBEDDED_DATA_MODAL';
export const SUBMIT_SUBSCRIPT = 'SUBMIT_SUBSCRIPT';

export const FILL_FORM_WITH_AI = 'FILL_FORM_WITH_AI';

/* Remote Case Actions */
export const CREATEWORK = 'createWork';
export const OPENASSIGNMENT = 'openAssignment';
export const OPENCASE = 'openCase';

/* Object Action Types */
export const CREATE_OBJECT = 'CREATE_OBJECT';
export const GET_OBJECT = 'GET_OBJECT';
export const OPEN_OBJECT_ACTION = 'OPEN_OBJECT_ACTION';
export const EXECUTE_OBJECT_WIDE_ACTION = 'EXECUTE_OBJECT_WIDE_ACTION';
export const CREATE_EXTERNAL_OBJECT = 'CREATE_EXTERNAL_OBJECT';
export const DELETE_WORK = 'DELETE_WORK';

export const ACTION_CREATEOBJECT = 'createObject';
export const ACTION_GETOBJECT = 'getObject';
export const ACTION_GETOBJECTWIDEACTION = 'getObjectWideAction';
export const ACTION_EXECUTE_OBJECT_ACTION = 'executeObjectWideAction';
export const ACTION_CREATE_EXTERNAL_OBJECT = 'createExternalObject';
export const ACTION_RETRIEVE_VIEW_FOR_OBJECT_CREATION = 'retrieveActionViewForNewObject';
export const ACTION_DELETE_WORK = 'deleteWork';
